import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";

import { UiService } from '@services/ui.service';
import { DerogationService } from '@services/derogation.service';
import { Derogation } from '@classes/derogation/derogation';

@Injectable()
export class DerogationResolver implements Resolve<Derogation[]> {
    constructor(
        private derogationSrv: DerogationService,
        private uiSrv: UiService,
        private router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Derogation[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.derogationSrv.get()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            }),
            catchError((error) => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                this.router.navigate(['/']);
                return throwError(error);
            })
        );
    }
}
